import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { quoteItemApi } from "@/main/api";
import StatusImportPartComponent from "@/main/components/shared/status/statusImportPartComponent";
import { MappingPartDetailInventoryRequest } from "@/main/models/request";
import {
	MappingPartDetailViewResponse,
	MappingPartSuggestionViewResponse,
	SupplierInventoryDataResponse,
} from "@/main/models/response";
import { getTranslateByKey, isEmpty, isNullUndefined, removeEmptyValues } from "@/main/services/utils";

import { IInventoryRegisterForm } from "../utilsInventoryRegisterScreen";
import { AreaFormMappingPart, DesiredPartMappingPart, GridMappingPart, InputMappingPart } from "./components";
import * as SP from "../styles";
import * as S from "./styles";

interface ISectionMappingPartsProps {
	dataInventory: SupplierInventoryDataResponse | null;
}
function SectionMappingParts({ dataInventory }: ISectionMappingPartsProps) {
	const [searchText, setSearchText] = useState("");
	const [isLoadingDataPart, setIsLoadingDataPart] = useState<boolean>(false);
	const [dataMappingPart, setDataMappingPart] = useState<MappingPartDetailViewResponse | null>(null);
	const [dataParts, setDataParts] = useState<MappingPartSuggestionViewResponse[]>([]);
	const { control } = useFormContext<IInventoryRegisterForm>();
	const watcherSupplier = useWatch({
		control,
		name: "supplier",
	});

	function getMappingParts(search: string) {
		if (isNullUndefined(watcherSupplier)) return;

		setIsLoadingDataPart(true);
		const request: MappingPartDetailInventoryRequest = {
			supplierDescription: search,
			supplier: watcherSupplier.value,
			partNumber: search,
			piesPartid: "",
			guidSupplierInventory: "",
		};

		quoteItemApi
			.getMappingPartDetailInventory(removeEmptyValues(request))
			.then((response) => {
				const { result } = response.data;
				setDataMappingPart(result);
				setDataParts(result.data);
				setIsLoadingDataPart(false);
			})
			.catch((e) => {
				const errorCanceled = "Some request were canceled due to performance";
				if (e !== errorCanceled) {
					setIsLoadingDataPart(false);
				}
			})
			.finally(() => {});
	}

	useEffect(() => {
		if (searchText) getMappingParts(searchText);

		return () => {
			setDataParts([]);
		};
	}, [searchText]);

	const haveStatus = !isNullUndefined(dataInventory) && !isEmpty(dataInventory.status);

	return (
		<S.Container>
			<S.HeaderSection>
				<SP.HeaderText>{getTranslateByKey("information.mappingPartSection")}</SP.HeaderText>
				{haveStatus && <StatusImportPartComponent status={dataInventory.idStatus} name={dataInventory.status} />}
			</S.HeaderSection>

			<InputMappingPart searchText={searchText} watcherSupplier={watcherSupplier} setSearchText={setSearchText} />
			<DesiredPartMappingPart />
			<GridMappingPart
				searchText={searchText}
				setSearchText={setSearchText}
				dataParts={dataParts}
				dataMappingPart={dataMappingPart}
				isLoading={isLoadingDataPart}
			/>

			<AreaFormMappingPart dataInventory={dataInventory} searchText={searchText} />
		</S.Container>
	);
}

export default SectionMappingParts;
